import React from 'react';
import { Outlet, Link, useNavigate, useLocation } from 'react-router-dom';
import { RiDashboardLine, RiNewspaperLine, RiPlantLine, RiGroupLine, RiLogoutBoxLine, RiAdvertisementFill, RiBookLine, RiMapPinLine, RiRoadMapLine, RiTeamLine, RiInformationLine } from 'react-icons/ri';

const AdminLayout = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleLogout = () => {
        localStorage.removeItem('adminToken');
        navigate('/admin/login');
    };

    const menuItems = [
        { label: 'Dashboard', icon: RiDashboardLine, path: '/admin' },
        { label: 'Manage News', icon: RiNewspaperLine, path: '/admin/news' },
        { label: 'Manage Families', icon: RiPlantLine, path: '/admin/families' },
        { label: 'Manage Genera', icon: RiPlantLine, path: '/admin/genera' },
        { label: 'Manage Species', icon: RiPlantLine, path: '/admin/species' },
        { label: 'Admin Users', icon: RiGroupLine, path: '/admin/users' },
        { label: 'Partners', icon: RiAdvertisementFill, path: '/admin/partners' },
        { label: 'Publications', icon: RiBookLine, path: '/admin/publications' },
        { label: 'Districts', icon: RiMapPinLine, path: '/admin/districts' },
        { label: 'Travel', icon: RiRoadMapLine, path: '/admin/travel' },
        { label: 'Manage Team', icon: RiTeamLine, path: '/admin/team' },
        { label: 'About Content', icon: RiInformationLine, path: '/admin/about' }
    ];

    return (
        <div className="min-h-screen bg-slate-50 flex font-sans">
            {/* Sidebar */}
            <aside className="w-64 bg-slate-900 text-white flex flex-col fixed h-full z-10">
                <div className="p-6 border-b border-slate-800">
                    <span className="text-emerald-500 font-black tracking-widest uppercase text-xs">COE Admin</span>
                    <h1 className="text-xl font-bold mt-1">Control Panel</h1>
                </div>

                <nav className="flex-1 p-4 space-y-2 overflow-y-auto">
                    {menuItems.map((item) => (
                        <Link
                            key={item.path}
                            to={item.path}
                            className={`flex items-center gap-3 px-4 py-3 rounded-xl transition-all ${location.pathname === item.path
                                ? 'bg-emerald-600 text-white shadow-lg shadow-emerald-900/20'
                                : 'text-slate-400 hover:bg-slate-800 hover:text-white'
                                }`}
                        >
                            <item.icon size={20} />
                            <span className="font-bold text-sm">{item.label}</span>
                        </Link>
                    ))}
                </nav>

                <div className="p-4 border-t border-slate-800">
                    <button
                        onClick={handleLogout}
                        className="flex items-center gap-3 px-4 py-3 w-full text-slate-400 hover:bg-red-500/10 hover:text-red-400 rounded-xl transition-all"
                    >
                        <RiLogoutBoxLine size={20} />
                        <span className="font-bold text-sm">Sign Out</span>
                    </button>
                    <div className="mt-4 px-4 text-xs text-slate-600 font-mono">
                        v2.0.4 Admin Build
                    </div>
                </div>
            </aside>

            {/* Main Content Area */}
            <main className="flex-1 ml-64 p-8 lg:p-12">
                <Outlet />
            </main>
        </div>
    );
};

export default AdminLayout;
